import { computed, ref, type Ref } from 'vue'
import { defineStore } from 'pinia'
import type { Room } from '@/models/Room'

export const useRoomStore = defineStore(
  'rooms',
  () => {
    const rooms: Ref<Room[]> = ref([])
    const getData = () => rooms.value
    const setData = (data: Room[]) => (rooms.value = data)

    const defaultRoom = computed(() => {
      return rooms.value.find((room) => room.isDefaultRoom) || null
    })

    const findByCode = (code: string) => {
      return rooms.value.find((room) => room.code === code) || null
    }

    const findByUuid = (uuid: string) => {
      return rooms.value.find((room) => room.uuid === uuid) || null
    }

    return {
      rooms,
      defaultRoom,
      getData,
      setData,
      findByCode,
      findByUuid
    }
  },
  {
    persist: true,
  },
)
